import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
@Component({
  selector: 'app-principal-slider',
  templateUrl: './principal-slider.component.html',
  styleUrls: ['./principal-slider.component.scss']
})
export class PrincipalSliderComponent implements OnInit {
  slickOptions: any = {
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: true,
    pauseOnHover: true,
    responsive: [],
  };
  @Input() public route: string;
  @Input() public load_serv: boolean = true;
  @Input() public redirect: boolean = true;
  @Input() public data: any = null;
  @Input() public video: any = '';
  public urlBaseS3: any = (<any>params).api.s3;
  public errors: any = null;
  public loadings: any = true;
  public videoValid: boolean;
  public videoUrl: any;
  constructor(
    private _homeService: HomeService,
    private sanitizer: DomSanitizer
  ) {
  }
  ngOnInit() {
    console.log('video: ', this.video);
    if (this.video !== '') {
      this.videoValid = true;
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlBaseS3 + this.video.url);
    }
    if (this.load_serv || this.data.length === 0) {
      this.getBanners();
    }
  }

  getBanners() {
    this._homeService.getBanners(this.route).subscribe(data => {
      this.data = data.data;
      if (!(data.data && data.data && data.data.length > 0)) {
        console.warn('Sin data para mostrar');
        this.loadings = false;
      }
    }, err => {
      console.error('Error al obtener data', err);
      this.errors = err;
    });
  }

  locationHref(url) {
    window.location.href = url;
  }

  reload() {
    this.loadings = true;
    this.getBanners();
  }
  onPlayerReady(event) {
    console.log('El video está listo', event.volume);
  }

}
